import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { SkapaSkeleton } from '@inter-ikea-guida/skapa';
const StyledSkeleton = styled(SkapaSkeleton) `
  position: relative;
  width: 100%;
  aspect-ratio: ${props => props.$aspectRatio};
  border-radius: ${props => props.$borderRadius};
`;
export const Skeleton = ({ aspectRatio, borderRadius = 'none' }) => {
    return (_jsx(StyledSkeleton, { "$aspectRatio": aspectRatio, "$borderRadius": borderRadius, width: '100%', height: '100%' }));
};
//# sourceMappingURL=Skeleton.js.map